<template>
	<div class="bg-color-5 text-color-text">
		<div class="flex justify-between gap-1 py-3 px-3 text-xs">
			<div class="w-3/5">
				<p>{{$t('eny.serviceTel')}}</p>
				<p>{{$t('eny.serviceMsg')}}</p>
			</div>
			<div class="w-2/5 text-right align-middle flex items-center">
				<span class="w-full">{{$t('eny.copywrite', { year: currentYear })}}</span>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	computed: {
		currentYear() {
			return new Date().getFullYear();
		}
	}
}
</script>
